/* ORO by Etchcraft — collection page behaviour (oro-plp.js) */
(function () {
  'use strict';
  var d = document;
  /* Read more on collection description */
  var desc = d.querySelector('[data-oro-desc]');
  var more = d.querySelector('[data-oro-more]');
  if (desc && more) {
    more.addEventListener('click', function () {
      var open = desc.getAttribute('data-open') === 'true';
      desc.setAttribute('data-open', open ? 'false' : 'true');
      more.setAttribute('aria-expanded', open ? 'false' : 'true');
      more.textContent = open ? 'Read more' : 'Show less';
    });
  }
  /* Staggered reveal of the first grid paint only; later pages/filters render instantly */
  var grid = d.querySelector('.main-collection .product-grid, .search-results .product-grid');
  if (!grid || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var host = grid.closest('.main-collection, .search-results') || grid.parentElement;
  host.classList.add('oro-reveal');
  var items = Array.prototype.slice.call(grid.children);
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var i = items.indexOf(e.target);
      setTimeout(function () { e.target.classList.add('is-in'); }, Math.min(i, 11) * 45);
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -5% 0px' });
  items.forEach(function (li) { io.observe(li); });
  /* Safety: anything appended later (filters, infinite scroll) shows immediately */
  new MutationObserver(function () {
    Array.prototype.forEach.call(grid.children, function (li) { if (items.indexOf(li) === -1) li.classList.add('is-in'); });
  }).observe(grid, { childList: true });
  setTimeout(function () { host.classList.remove('oro-reveal'); items.forEach(function (li) { li.classList.add('is-in'); }); }, 4000);
})();
